import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { isEmpty, round } from 'lodash';

import Color from '@tool/color';

interface IProps {
  active:string
  list:any
  index:number
}
interface IState {}

const CityTable = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { active, list, index } = props;

  useEffect(() => {
    return () => {};
  }, []);

  const colorList = [
    '',
    Color.cf,
    Color.primary,
    Color.secondary,
  ];

  return (
    <section className="city-table-warp">
      {active === 'num' && <section>
        <section className="table-title">
          {[
            '',
            '上期招聘量',
            '当期招聘量',
            '招聘量环比变化率',
          ].map((res: any, i: any) => {
            return (
              <p key={i} style={{ background: colorList[i] }}>
                {res}
              </p>
            );
          })}
        </section>
        <section className="table-content">
          {list?.map((res: any, i: any) => {
            return (
              <p key={i}>
                <span style={{ background:index === 0 && i === 0 ? Color.c333 : Color.c999 }}>{res.city}</span>
                <span>{res.amount_previous?.toLocaleString()}</span>
                <span>{res.amount_current?.toLocaleString()}</span>
                <span
                  style={{
                    background: res.amount_change > 0 ? '#FBE8E8' : '#E5F9F3',
                    color: res.amount_change > 0 ? Color.error : Color.success,
                  }}>
                  {`${round(res.amount_change * 100, 1)}%`}
                </span>
              </p>
            );
          })}
        </section>
      </section>}

      {active === 'salary' && <section>
        <section className="table-title">
          {[
            '',
            '上期招聘薪酬（元）',
            '当期招聘薪酬（元）',
            '招聘薪酬环比变化率（元）',
          ].map((res: any, i: any) => {
            return (
              <p key={i} style={{ background: colorList[i] }}>
                {res}
              </p>
            );
          })}
        </section>
        <section className="table-content">
          {list?.map((res: any, i: any) => {
            return (
              <p key={i}>
                <span>{res.city}</span>
                <span>{res.salary_previous?.toLocaleString()}</span>
                <span>{res.salary_current?.toLocaleString()}</span>
                <span
                  style={{
                    background: res.salary_change > 0 ? '#FBE8E8' : '#E5F9F3',
                    color: res.salary_change > 0 ? Color.error : Color.success,
                  }}>
                  {`${round(res.salary_change * 100, 1)}%`}
                </span>
              </p>
            );
          })}
        </section>
      </section>}
    </section>
  );
};

export default observer(CityTable);
